import React, { useEffect, useState } from 'react'
import adminStyles from './adminStyles.module.css'
import { useNavigate, useParams } from 'react-router-dom'
import axios from 'axios'

const EditLocation = () => {
   const[trname,setTrname]=useState("")
   const[location,setLocation]=useState("")
    const{sid}=useParams();
    const navigate=useNavigate();

     useEffect(()=>{
    axios.get(`https://backendsurgylife-1.onrender.com/location/${sid}`)
    .then((res)=>{
        setTrname(res.data.trname)
        setLocation(res.data.location)
    })
    .catch((err)=>{
      alert("Error Fetching Location")
    })
  },[])

  const updateLocationData=(e)=>{
    e.preventDefault()
    axios.put(`https://backendsurgylife-1.onrender.com/location/${sid}`,{
      trname,
      location,
    })
  .then((res)=>{
    alert("Location Updated Successfully")
    navigate("/admindashboard/deletelocation")
  })
   .catch((err)=>{
    alert("Error while Updating The location")
   })
  }

  return (
  <main className={adminStyles.adminMain}>
           
                   <section className={adminStyles.breadgum}>
                       <div className='container'>
                           <div className='row'>
                               <div className='col-md-12'>
                                   <h1>Edit Location</h1>
                               </div>
                           </div>
                       </div>
                   </section>

                                <section className='py-5'>
                                  <div className='container'>
                                     <div className='row'>
                                         <div className='col-md-6 mx-auto' >
                     
                                          <div className={adminStyles.bx_shadow}>
                                           <form onSubmit={updateLocationData}>
                                           <div className='mb-3'>
                     
                                                     <input 
                                                      type='text'
                                                      name='trname'
                                                       placeholder='Treatment Name' 
                                                       className='form-control'
                                                       value={trname}
                                                       onChange={
                                                         (e)=>setTrname(e.target.value)
                                                       }
                                                       />
                                                       </div>

                                                       <div className='mb-3'>
                     
                                                        <textarea 
                                                        className='form-control'
                                                        placeholder='Location'
                                                        value={location}
                                                        onChange={
                                                         (e)=>setLocation(e.target.value)
                                                        }
                                                        >
                     
                                                        </textarea>
                     
                                                       </div>
                     
                                                         <div className='mb-3'>
                                                           
                                                     <input 
                                                     type='submit' 
                                                     value='Update Location'
                                                     className='btn btn-success'/>  
                     
                                                         </div>
                     
                                                      </form>
                     
                                               
                     
                                                     </div>
                     
                                                    </div>
                                                </div>
                                            </div>
                                        </section>

                   </main>
  )
}

export default EditLocation
